var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,.cls-2,.cls-4,.cls-5,.cls-8{fill:none;stroke-linecap:round;stroke-miterlimit:10;}.cls-1,.cls-8{stroke:#ccdaff;}.cls-2,.cls-4{stroke:#99b5ff;}.cls-2,.cls-8{stroke-width:1.5px;}.cls-3{fill:#99b5ff;}.cls-5{stroke:#4d7eff;stroke-width:2px;}.cls-6{fill:#ccdaff;}.cls-7{fill:#e6ecff;}.cls-9{fill:#4d7eff;}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.8 28.53a8 8 0 00.2-1.63c0-4-2.75-7.19-6.14-7.19a5.42 5.42 0 00-.58.06c-1.32-4.21-4.77-7.23-8.84-7.23-4.23 0-7.8 3.26-9 7.76a8.11 8.11 0 00-3.44-.75c-4.59 0-8.38 3.88-9.2 9M14.33 28.53h-4.09M19.98 30.6H.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.06 27.68l.03 2.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 81.34,
    cy: 42.09,
    r: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.82 42.21h30.73M87.02 42.21h10.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.07 16.82l.03 3.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.17 41a.93.93 0 01-.81 1.4L23 42.27a.45.45 0 01-.39-.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.55 42.55a1.64 1.64 0 00-.67-1.17c-2.47-2.2-11.72-4-24.24-4.84C77.14 36.17 71 36 64.58 36c-6.1 0-11.89.26-17.14.65-13.79 1-23.8 3.12-25.5 5.58a1.3 1.3 0 00-.27.74c0 3.74 19.26 6.67 43 6.55s42.9-3.24 42.88-6.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.38 36.48l.05 6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47.29 37.64c2.45-4.49 17.52-29.45 35.19-.11 12.53.85 22.48 2.34 25 4.53 0-.15-.42-.56-.7-.81-42.38-38.88-78-6.25-84.95.93a.59.59 0 00-.16.79c1.7-2.45 11.82-4.32 25.62-5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47.29 37.64c5.25-.39 11-.62 17.13-.65 6.45 0 12.57.17 18.06.54-17.67-29.34-32.74-4.38-35.19.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95.12 48.47l.03 3.38M95.14 54.14l.01 1.69M31.08 50.54l.03 3.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87 19.01l.03 2.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.65 59.62l.03 2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.74 26.71l.03 1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.78 42.97l.03 1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.61 33.87l-.03-3.38M36.59 28.2l-.01-1.68M21.5 36.35l-.02-.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.41 25.9a.75.75 0 01-.75-.74v-1.69a.73.73 0 01.74-.75.75.75 0 01.75.74v1.69a.75.75 0 01-.74.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.53 25.5a10.74 10.74 0 00-1.42.62c-.67.61-.13 1.32 1.2 1.15.5-.06 1.92.19 2.51.11.75-.09 3.08-2.6 1.29-2.84a7.64 7.64 0 00-1.9.43 5.53 5.53 0 00-1.68.53zM93.25 32.28a.75.75 0 01-.75-.74v-1.69a.75.75 0 01.75-.75.74.74 0 01.75.74v1.69a.75.75 0 01-.74.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.3 31.64a8.06 8.06 0 00-1.3.86c-.67.61.87 1.87 2.22 1.87s1.45 1.71 2 1.63 1.4-2.82.82-3.31a11.8 11.8 0 00-2-1.34c-.43-.24-1-.61-1.4-.43-.17.08-.09.59-.34.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M76.36 85.14a1 1 0 00-1 1 4.32 4.32 0 01-8.61.07l-.35-38.73a1 1 0 00-1-1 1 1 0 00-1 1l.35 38.64V86.41a.5.5 0 000 .13 6.32 6.32 0 0012.6-.42 1 1 0 00-.99-.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.07 14.07a6.86 6.86 0 00.15-1.38c0-3.37-2.33-6.1-5.22-6.1a4.28 4.28 0 00-.49 0C109.39 3.06 106.46.5 103 .5s-6.63 2.77-7.64 6.59a6.84 6.84 0 00-2.87-.64c-3.9 0-7.12 3.29-7.82 7.62M82.55 14.07h-3.47M93.28 17.71h15.08"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.4ab84a6d.svg";
export { ForwardRef as ReactComponent };